import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const AgentsIntroPage = lazy(() =>
  import('./AgentsIntroPage').then((m) => ({ default: m.AgentsIntroPage })),
);

/**
 * The AI Agents page, at `/agents`: the page that fronts both agents, so it neither redirects to one of them
 * nor belongs to either's module.
 *
 * <p>Listed inside the `<ProductRoute />` group in `app/router`, ahead of `placeholderRoutes`, for the reasons
 * `features/emailWarmup/index.tsx` gives; `ROUTES.aiAgent` is in the placeholder's `BUILT_ROUTES`.
 */
export const agentsOverviewRoutes: RouteObject[] = [
  { path: ROUTES.aiAgent, element: <AgentsIntroPage /> },
];
